import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { UserSessionService } from "src/app/services/usersession.service";
import swal from "sweetalert2";
import * as _ from "lodash";
import { TranslateService } from "@ngx-translate/core";
import { MatDialog } from "@angular/material/dialog";
import { FormGroup } from "@angular/forms";
import { AuthenticationService } from "src/app/services/authentication.service";
import { environment } from "src/environments/environment";
import * as jwtDecode from 'jwt-decode';
import { DOCUMENT } from "@angular/common";

@Component({
  selector: 'app-bc-navbar',
  templateUrl: './bc-navbar.component.html',
  styleUrls: ['./bc-navbar.component.scss']
})
export class BCNavbarComponent implements OnInit {

  username: any;
  userId: number;
  emailId: any;
  auth: any;
  webversion: any;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    public translate: TranslateService,
    private userSessionService: UserSessionService,
    private router: Router,
    public dialog: MatDialog,
    private authService: AuthenticationService,
  ) {
    this.userId = userSessionService.userId();
    this.emailId = userSessionService.getEmail();
    this.username = userSessionService.cardholdername();
  }

  ngOnInit(): void {
    this.versionCheck()
  }

  versionCheck() {
    var data = {
      keys: ["version"]
    }
    this.authService.getNotification(data).subscribe((res) => {
      this.webversion = res.version;
    })
  }


  onLogout(e) {
    e.preventDefault();
    const title = this.translate.instant("Would you like to logout?");
    const Yes = this.translate.instant("Yes");
    const No = this.translate.instant("No");
    swal
      .fire({
        title,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: Yes,
        cancelButtonText: No,
        allowOutsideClick: false

      })
      .then((result) => {
        if (result.value) {
          e.preventDefault();
          localStorage.removeItem("isLoggedin");
          this.removeLocalStorageData();
          if (!localStorage.getItem("isLoggedin")) {
            this.router.navigate(["/auth/login"]);
          }
        }
      });
  }

  removeLocalStorageData() {
    localStorage.removeItem("menu");
    localStorage.removeItem('eGramam-' + environment.apiBaseUrl + '-AuthData');
    localStorage.removeItem("fromdate");
    localStorage.removeItem("fromdate_val");
    localStorage.removeItem("otpStatus");
    localStorage.removeItem("status");
    localStorage.removeItem("toDate");
    localStorage.removeItem("menuClient");
    localStorage.removeItem("clientChange");
    localStorage.removeItem("roleID");
    localStorage.removeItem("resellerId");
    localStorage.removeItem("clientChangeID");
    localStorage.removeItem("data1");
    localStorage.removeItem("clientId");
    localStorage.removeItem("todate_val");
    localStorage.removeItem("deptId");
    sessionStorage.removeItem("email");
    sessionStorage.removeItem("mobile");
    sessionStorage.removeItem("otp_to");
    sessionStorage.removeItem("clientId");
  }

  toggleSidebar(e) {
    e.preventDefault();
    this.document.body.classList.toggle("sidebar-open");
  }

}
